// Import the functions you need from the SDKs you need
import {initializeApp} from "firebase/app";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries
import {getAuth, signInWithEmailLink, sendSignInLinkToEmail, isSignInWithEmailLink} from "firebase/auth"

// Your web app's Firebase configuration
export const firebaseConfig = {
    apiKey: "AIzaSyC9TF20EA0II-JzXyurvfcsTxFvP8OEQgg",
    authDomain: "potbot-9f9ff.firebaseapp.com",
    projectId: "potbot-9f9ff",
    databaseURL: "https://potbot-9f9ff-default-rtdb.europe-west1.firebasedatabase.app",
    storageBucket: "potbot-9f9ff.appspot.com",
    messagingSenderId: "186487305663",
    appId: "1:186487305663:web:870f258e894342d1595d0a"
};

// Initialize Firebase
// const app = initializeApp(firebaseConfig);
// export const auth = getAuth(app);

// const actionCodeSettings = {
//     url: 'http://localhost:3000/?email=pontuskinnmark@gmail.com',
//     handleCodeInApp: true
// };

// Obtain emailLink from the user.


    // export function signIn() {
    //     sendSignInLinkToEmail(auth, 'pontuskinnmark@gmail.com', actionCodeSettings).then(res => console.log(res)).catch(err => console.error(err));
    // }